module.exports = __webpack_public_path__ + "img/Pag5.f83761b3.png";